<div class="top">
    <div class="right">
        <div class="action-buttons" (click)="$event.stopPropagation()">
            <ng-container *ngIf="account; else actionButtonsPlaceholders">
                <div [egovTooltip]="account?.paymentBlocked ? paymentBlockedTooltip : null">
                    <ng-template #paymentBlockedTooltip>
                        <div style="max-width: 350px" [innerHTML]="(blockMessages$ | async)?.paymentForbidden | MarkdownToHtml"></div>
                    </ng-template>
                    <app-icon-button
                        [title]="addAccountToOrRemoveFromCartTitle$ | async"
                        [disabled]="!(payable$ | async)"
                        (click)="toggleAccountInCart($event)"
                        [spinner]="updatingCartState$ | async"
                    >
                        {{ (accountInCart$ | async) ? "remove_shopping_cart" : "add_shopping_cart" }}
                    </app-icon-button>
                </div>
                <app-icon-button [moreIconAtTheEnd]="true" [matMenuTriggerFor]="accountMenu" (click)="$event.stopPropagation()"> more_vert </app-icon-button>
                <mat-menu #accountMenu="matMenu" xPosition="before" overlapTrigger>
                    <button mat-menu-item (click)="toggleAccountInCart()" [disabled]="!(payable$ | async)">
                        {{ !(accountInCart$ | async) ? "Add to Cart" : "Remove from Cart" }}
                    </button>
                    <mat-divider></mat-divider>
                    <button class="auto-draft" *ngIf="autoDraftEnabled$ | async" mat-menu-item (click)="showAutoDraftDialog(account.accountNumber)">
                        Auto-Draft
                    </button>
                    <button class="subscriptions" *ngIf="subscriptionsEnabled$ | async" mat-menu-item (click)="showSubscriptionsDialog(account.accountNumber)">
                        Subscriptions
                    </button>
                    <button mat-menu-item class="watch" *ngIf="(watchListsEnabled$ | async) === true" (click)="watchAccount(account.accountNumber)">
                        Watch
                    </button>
                </mat-menu>
            </ng-container>
            <ng-template #actionButtonsPlaceholders class="action-buttons">
                <app-icon-button [placeholder]="true"></app-icon-button>
                <app-icon-button [placeholder]="true"></app-icon-button>
            </ng-template>
        </div>
    </div>
    <div class="left">
        <p class="account-number unimportant-text">
            <ng-container *ngIf="account; else accountPlaceholder"> Account #{{ account.accountNumber }} </ng-container>
            <ng-template #accountPlaceholder>
                <egov-text-ui-placeholder>Account #00000</egov-text-ui-placeholder>
            </ng-template>
        </p>
        <h4 class="header-text title is-clickable">
            <ng-container *ngIf="account; else titlePlaceholder">
                {{ title$ | async }}
            </ng-container>
            <ng-template #titlePlaceholder>
                <egov-text-ui-placeholder [length]="60" [lengthThreshold]="15"></egov-text-ui-placeholder>
            </ng-template>
        </h4>
    </div>
</div>
<div class="bottom">
    <div class="some-data">
        <!-- Define a common placeholder for these values -->
        <ng-template #dataPointValuePlaceholder>
            <div class="icon-placeholder"></div>
            <div class="text">
                <div class="value">
                    <egov-text-ui-placeholder [length]="70" [lengthThreshold]="20"></egov-text-ui-placeholder>
                </div>
                <div class="label"><egov-text-ui-placeholder [length]="15"></egov-text-ui-placeholder></div>
            </div>
        </ng-template>

        <div class="data-point business-address">
            <ng-container *ngIf="(hasBusinessAddress$ | async) !== undefined; else dataPointValuePlaceholder">
                <mat-icon>business</mat-icon>
                <div class="text">
                    <div class="value">
                        <ng-container *ngIf="(hasBusinessAddress$ | async) !== false">{{ businessAddress$ | async }}</ng-container>
                        <app-na *ngIf="(hasBusinessAddress$ | async) === false"></app-na>
                    </div>
                    <div class="label">Business Address</div>
                </div>
            </ng-container>
        </div>
        <div class="data-point mailing-address">
            <ng-container *ngIf="(hasMailingAddress$ | async) !== undefined; else dataPointValuePlaceholder">
                <mat-icon>mail</mat-icon>
                <div class="text">
                    <div class="value">
                        <ng-container *ngIf="(hasMailingAddress$ | async) !== false">{{ mailingAddress$ | async }}</ng-container>
                        <app-na *ngIf="(hasMailingAddress$ | async) === false"></app-na>
                    </div>
                    <div class="label">Mailing Address</div>
                </div>
            </ng-container>
        </div>
        <div class="data-point types-of-business">
            <ng-container *ngIf="(hasTypesOfBusiness$ | async) !== undefined; else dataPointValuePlaceholder">
                <mat-icon>business_center</mat-icon>
                <div class="text">
                    <div class="value">
                        <ul *ngIf="hasTypesOfBusiness$ | async; else typesOfBusinessNotAvailable">
                            <li *ngFor="let type of typesOfBusiness$ | async">{{ type.description }}</li>
                        </ul>
                        <ng-template #typesOfBusinessNotAvailable><app-na></app-na></ng-template>
                    </div>
                    <div class="label">Business / Occupation</div>
                </div>
            </ng-container>
        </div>
    </div>
    <btax-account-balance [accountNumber]="account?.accountNumber"></btax-account-balance>
</div>
